export default __webpack_public_path__ + "static/media/fundsize-icon.a67a593d.svg";